export default "/_next/static/a97cad959e1264132b297a6b125c16f1.jpg";